var project = function (win, $) {

  function init() {

    keyboardNavMenu();
    //windowScrollAnimations();
    //menuscroll();
    //menuAnimation();
    menuCollapse();
    //fontSizing();
    heroDownArrow();
    //subnavboxStickyNav();
    // subnavboxJumplinks();
    jumpToHash();
    countUpControl();

    var dwidth = $(window).width();

    document.documentElement.style.setProperty('--menu-offset', $('.navbar').outerHeight() + 'px');

    $(window).resize(function () {
      document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");

      var wwidth = $(window).width();

      if (dwidth !== wwidth) {
        dwidth = $(window).width();
        document.documentElement.style.setProperty('--menu-offset', $('.navbar').outerHeight() + 'px');
      }

    }).resize();

    $(document).on('click', '.toggle', function (e) {
      /* toggle content with ID of elements data-target */
      var target = $(this).attr('data-target');
      if (target) {
        if ($(this).hasClass('nav-toggle')) {
          /* insert/remove menu overlay */

          $('body').toggleClass('mobile-nav-show');

          if ($('.menu-overlay').length) {
            $('.menu-overlay').remove();
          } else {
            $('body').append('<div class="menu-overlay"></div>');
          }
        }
        $(target).slideToggle();
        $(this).toggleClass('toggle-closed');
        e.preventDefault();
      }
    });

    $(document).on('click', '.menu-overlay', function (e) {
      $('.nav-toggle').trigger('click');
    });

    function countUpControl() {

      var stats = $('.card-stats');

      if (!stats[0]) {
        return false;
      }

      stats.each(function () {

        var stat = $(this);
            number = stat.find('.title strong'),
            endValue = stat.data('target');

        number.countup(endValue, {
          startVal: 0,
          duration: 2.5,
          useEasing: true,
          useGrouping: true,
          separator: ",",
        });
      });
    }

    function keyboardNavMenu() {
      var menuItems = $("#block-dvinci-main-menu ul.submenu").parent();

      menuItems.addClass("has-submenu");

      menuItems.each(function (e, i) {

        var menuItem = $(this),
          menuBtn = menuItem.find(' > a, > button'),
          btnIcon = menuBtn.find('i'),
          timer2;

        menuItem.on('mouseenter', function () {
          btnIcon.removeClass("fa-caret-down").addClass("fa-caret-up");
        }).on('mouseleave', function () {
          btnIcon.removeClass("fa-caret-up").addClass("fa-caret-down");
        });

        menuBtn.on("focus", function (e) {
          if (menuItem.hasClass('has-submenu')) {
            menuItem.addClass('open').attr('aria-expanded', "true");
            btnIcon.removeClass("fa-caret-down").addClass("fa-caret-up");
          } else {
            menuItem.removeClass('open').attr('aria-expanded', "false");
            btnIcon.removeClass("fa-caret-up").addClass("fa-caret-down");
          }
        });

        menuItem.on("focusin", function () {
          if (timer2) {
            clearTimeout(timer2);
            timer2 = null;
          }
        }).on("focusout", function (event) {
          timer2 = setTimeout(function () {
            if (menuItem.hasClass('has-submenu')) {
              menuItem.removeClass('open').attr('aria-expanded', "false");
              btnIcon.removeClass("fa-caret-up").addClass("fa-caret-down");
            }
          }, 10);
        });

      });
    }

    function windowScrollAnimations() {
      if ($(window).scrollTop() >= 25) {
        $('body').addClass('nav-small');

      } else {
        $('body').removeClass('nav-small');
      }
    }

    $(window).bind('scroll', windowScrollAnimations);

  }

  function fontSizing() {

    var block = $('.block');

    block.each(function () {

      var this_block = $(this);
      blockClasses = (this_block.attr('class') || '').split(' ');

      for (var i = 0, len = blockClasses.length; i < len; i++) {
        switch (blockClasses[i]) {
          case 'hero':

            if (this_block.hasClass('hero-interior')) {
              var block_h1 = this_block.find('h1'),
                block_h1_secondary = block_h1.find('strong'),
                block_p = this_block.find('p');

              block_h1.fitText(1.35, { minFontSize: '36px', maxFontSize: '60px' });
              block_h1_secondary.fitText(.75, { minFontSize: '36px', maxFontSize: '100px' });
              block_p.fitText(1.5, { minFontSize: '18px', maxFontSize: '24px' });

              if (this_block.hasClass('alternate')) {

                var block_h2 = this_block.find('h2');

                block_h2.fitText(1, { maxFontSize: '22px' });
              }

            } else {

              var block_h1 = this_block.find('h1'),
                block_h1_secondary = block_h1.find('strong'),
                block_h2 = this_block.find('h2');

              block_h1.fitText(.5, { maxFontSize: '120px' });
              block_h1_secondary.fitText(.65, { maxFontSize: '80px' });
              block_h2.fitText(1, { maxFontSize: '32px' });

            }

            break;

          case 'text-curved-image':

            if (!this_block.hasClass('text-curved-image-locations')) {

              var block_h2 = this_block.find('h2'),
                block_h2_secondary = block_h2.find('strong'),
                block_p = this_block.find('p');

              block_h2.fitText(.75, { maxFontSize: '48px' });
              block_h2_secondary.fitText(.65, { maxFontSize: '80px' });
              block_p.fitText(1.25, { maxFontSize: '20px' });

            }

            break;

          case 'card-grid':

            var block_h2 = this_block.find('h2'),
              block_h3 = this_block.find('h3'),
              block_p = this_block.find('p'),
              block_li = this_block.find('li');
            block_li_icon = block_li.find('.fas');

            block_h2.fitText(.75, { maxFontSize: '64px' });
            block_h3.fitText(.75, { maxFontSize: '24px' });
            block_p.fitText(1.25, { maxFontSize: '20px' });
            block_li.fitText(1, { minFontSize: '16px', maxFontSize: '20px' });
            block_li_icon.fitText(1, { minFontSize: '10px', maxFontSize: '12px' });

            break;

          case 'client-profile':

            var block_h2 = this_block.find('h2'),
              block_p = this_block.find('p');

            block_h2.fitText(.75, { maxFontSize: '64px' });
            block_p.fitText(1.25, { maxFontSize: '20px' });

            break;

          case 'halo-block':

            var block_h2 = this_block.find('h2');
            var block_h2_small = block_h2.find('small'),
              block_h2_strong = block_h2.find('strong');
            block_h2.fitText(.75, { maxFontSize: '135px' });
            // block_h2_small.fitText(1, { minFontSize: '30px', maxFontSize: '43px' });
            block_h2_strong.fitText(.75, { maxFontSize: '109px' });

            break;

          case 'image-grid':

            var block_h2 = this_block.find('h2'),
              block_p = this_block.find('p');

            block_h2.fitText(.75, { maxFontSize: '64px' });
            block_p.fitText(1.25, { maxFontSize: '20px' });

            break;

          case 'project-highlight':

            var block_h2 = this_block.find('h2');

            block_h2.fitText(1, { maxFontSize: '64px' });

            break;

          case 'features-grid':

            var block_h2 = this_block.find('h2'),
              block_p = this_block.find('p');

            block_h2.fitText(1, { minFontSize: '38px', maxFontSize: '64px' });
            block_p.fitText(1.25, { maxFontSize: '20px' });

            break;

          case 'info-block':

            var block_h2 = this_block.find('h2'),
              block_p = this_block.find('p'),
              card = this_block.find('.card'),
              card_h3 = card.find('h3'),
              card_p = card.find('p'),
              card_list = card.find('ul:not(.fancy) > li');

            console.log(card_list);

            block_h2.fitText(1, { minFontSize: '38px', maxFontSize: '64px' });
            block_p.fitText(1.25, { minFontSize: '16px', maxFontSize: '20px' });
            card_h3.fitText(1, { minFontSize: '24px', maxFontSize: '30px' });
            card_p.fitText(1.25, { minFontSize: '16px', maxFontSize: '20px' });
            card_list.fitText(1.25, { minFontSize: '14px', maxFontSize: '20px' });

            break;

          case 'news':

            var block_h2 = this_block.find('h2'),
              block_h3 = this_block.find('h3'),
              block_p = this_block.find('p');

            block_h2.fitText(.75, { maxFontSize: '64px' });
            block_h3.fitText(1, { maxFontSize: '28px' });
            block_p.fitText(1.25, { maxFontSize: '20px' });

            break;

          case 'call-to-action':

            if (this_block.hasClass('one')) {
              var block_h2 = this_block.find('h2'),
                block_p = this_block.find('p');

              block_h2.fitText(.65, { maxFontSize: '60px' });
              block_p.fitText(1.75, { maxFontSize: '20px' });
            }
            if (this_block.hasClass('two')) {
              var block_h2 = this_block.find('h2'),
                block_p = this_block.find('p');

              block_h2.fitText(1, { maxFontSize: '24px' });
              block_p.fitText(1.75, { maxFontSize: '18px' });
            }
            if (this_block.hasClass('three')) {
              var block_h2 = this_block.find('h2'),
                block_p = this_block.find('p');

              block_h2.fitText(1.10, { maxFontSize: '24px' });
              block_p.fitText(1.75, { maxFontSize: '18px' });
            }

            break;

          case 'video-block':

            var block_h2 = this_block.find('h2'),
              block_h3 = this_block.find('h3'),
              block_p = this_block.find('p');

            block_h2.fitText(1, { maxFontSize: '64px' });
            block_h3.fitText(1.5, { maxFontSize: '32px' });
            block_p.fitText(1.25, { minFontSize: '16px', maxFontSize: '20px' });

            break;

          case 'text-block':

            var block_h2 = this_block.find('h2'),
              block_h3 = this_block.find('h3'),
              block_h4 = this_block.find('h4'),
              block_p = this_block.find('p');

            block_h2.fitText(1, { maxFontSize: '64px' });
            block_h3.fitText(1.5, { minFontSize: '24px', maxFontSize: '32px' });
            block_h4.fitText(1.5, { minFontSize: '18px', maxFontSize: '24px' });
            block_p.fitText(1.5, { minFontSize: '16px', maxFontSize: '20px' });

            break;

          case 'project-highlight':

            var block_h2 = this_block.find('h2'),
              block_h3 = this_block.find('h3'),
              block_h4 = this_block.find('h4'),
              block_p = this_block.find('p');

            block_h2.fitText(1, { maxFontSize: '64px' });
            block_h3.fitText(1, { maxFontSize: '24px' });
            block_h4.fitText(1, { maxFontSize: '18px' });
            block_p.fitText(1.25, { minFontSize: '16px', maxFontSize: '20px' });

            break;

          case 'sparkleheader-block':

            var block_h1 = this_block.find('h1');
            block_h1.fitText(1.25, { maxFontSize: '92px' });

            break;

          case 'thinkingindex-block':

            var result_h2s = this_block.find('.thinkingindex-result-body h2');
            result_h2s.fitText(1.25, { maxFontSize: '34px' });

            break;

          case 'textandforma-block':

            var text_titles = this_block.find('.textandforma-text-title');
            console.log(text_titles.length);
            text_titles.fitText(1, { maxFontSize: '56px' });

            break;

          case 'govexp-block':

            var block_h2 = this_block.find('h2');
            block_h2.fitText(1, { maxFontSize: '68px' });

            break;

          default:
        }
      }
    });
  }

  function menuCollapse() {

    var menu = $('#menu'),
      menu_parent,
      menu_collapse = menu.find('.submenu')

    menu_collapse.on('show.bs.collapse', function (e) {
      menu_parent = menu.find('#' + e.target.previousElementSibling.id);
      menu_parent.addClass('shown').removeClass('collapsed');
    });
    menu_collapse.on('hide.bs.collapse', function (e) {
      menu_parent = menu.find('#' + e.target.previousElementSibling.id);
      menu_parent.addClass('collapsed').removeClass('shown');
    });

  }

  function menuAnimation() {

    var menu = $('#menu'),
      btn = $('.app .navbar button'),
      modal_close = $('.modal .btn-close'),
      body = $('body');

    modal_close.on('focusin', function () {
      btn.addClass('focused');
    }).on('focusout', function (e) {
      btn.removeClass('focused');
    });

    btn.on('click', function (e) {
      e.preventDefault();

      menu.on('hide.bs.modal', function (e) {

        body.removeClass('main-nav-modal-open');

        if (menu.hasClass('animate__slideInDown')) {
          e.preventDefault();
          menu.removeClass('animate__slideInDown').addClass('animate__slideOutUp');

          setTimeout(function () {
            menu.modal('toggle');
          }, 150);
        }

      });

      menu.on('show.bs.modal', function (e) {
        body.addClass('main-nav-modal-open');
        menu.removeClass('animate__slideOutUp').addClass('animate__slideInDown');
      });

      menu.modal('toggle');


    });
  }

  function menuscroll() {

    var previousScroll = 0;

    $(window).scroll(function (e) {

      // add/remove class to navbar when scrolling to hide/show
      var scroll = $(window).scrollTop(),
        navbar = $('.navbar'),
        navbar_height = navbar.height(),
        navbar_offset = "-" + navbar_height + "px";

      console.log(scroll);
      console.log(navbar_offset);

      if (scroll > 0) {
        navbar.addClass('fixed-top');
      } else if (scroll <= 0) {
        navbar.removeClass('fixed-top');
      }
      previousScroll = scroll;

    });

  }

  function heroDownArrow() {
    var arrow = document.querySelector('.hero-down-arrow');
    if (arrow) {
      arrow.addEventListener('click', function (e) {
        e.preventDefault();
        // document.querySelector('section').nextElementSibling.scrollIntoView();
        // var nextSection = document.querySelector('section').nextElementSibling;
        var $heroSection = $(this).closest('section');
        var $nextSection = $heroSection.next('section');
        var nextSectionOffset = $nextSection.offset();
        var navOffset = measureNavOffset();
        var scrollTop = nextSectionOffset.top - navOffset;
        // $(window).scrollTo(scrollTop);
        window.scrollTo({ top: scrollTop, behavior: 'smooth' })
      });
    }
  }

  /**
   * Unfortunately, the way that certain ancestor elements are built/styled
   * prevents us from using position: sticky here. So we'll do it the
   * old-school way instead.
   */
  /*
  function subnavboxStickyNav() {

      var $window = $(window);
      var $box = $('div.subnavbox').first();
      var minWindowWidth = 992; // stickiness won't be applied if the window is narrower than this
      var offset = 140; // stickiness will kick in when the subnav is this many pixels below the top of the viewport

      if (!$box.length) {
          return;
      }

      var $subnav = $('ul.subnavbox-subnav', $box);
      var windowWidth;
      var subnavNaturalTop; // natural distance from the top of the document to the top of the subnav (when position: fixed is not applied)
      var subnavNaturalWidth;

      $window.on('resize', function () {
          measureAndReposition();
      });

      $window.on('scroll', function () {
          reposition();
      });

      measureAndReposition();

      function measureAndReposition() {
          unstick();
          windowWidth = $window.width();
          subnavNaturalTop = $subnav.offset().top;
          subnavNaturalWidth = $subnav.width();
          reposition();
      }

      function reposition() {

          var stick = false;
          var windowScrollTop;

          if (windowWidth >= minWindowWidth) {
              windowScrollTop = $window.scrollTop();
              if (windowScrollTop >= subnavNaturalTop - offset) {
                  stick = true;
              }
          }

          if (stick) {

              $subnav.css({
                  position: 'fixed',
                  top: offset + 'px',
                  width: subnavNaturalWidth,
              });

          } else {

              unstick();

          }

      }

      function unstick() {

          $subnav.css({
              position: '',
              top: '',
              width: '',
          });

      }

  }
  */

  /**
   * The main nav floats above the rest of the page, so if you jump directly
   * to an element, the top of the element is obscured behind the main nav.
   * 
   * This function provides a custom jumplink implementation which solves this. 
   */
  /*
  function subnavboxJumplinks() {

    var $window = $(window);
    var offset = 165; // the viewport will be scrolled this many pixels above the jumplink's target

    var $jumplinkContainers = $('ul.subnavbox-subnav, div.subnavbox-main');

    $jumplinkContainers.on('click', 'a', function (e) {
   
      var $clickedLink = $(e.target);
      var sectionHash = $clickedLink.get(0).hash;
      var $section = $(sectionHash);

      if ($section.length) {
        e.preventDefault();
        document.location.hash = sectionHash;
        var sectionTop = $section.offset().top;
        var newScrollTop = sectionTop - offset;
        if (newScrollTop < 0) {
            newScrollTop = 0;
        }
        $window.scrollTo(newScrollTop);
      }

    });

  }
  */

  /**
   * If the URL contains a hash at domload time, then move the viewport to
   * bring it into focus (accounting for the floating nav)
   */
  function jumpToHash() {

    var currentUrl = new URI();
    var fragment = currentUrl.fragment();

    if (!fragment.length) {
      return;
    }

    var $target = $('#' + fragment);

    if (!$target.length) {
      return;
    }

    // Give the browser a moment - it might not've finished its own jump to
    // the #hash yet
    window.setTimeout(function () {
      var targetPosition = $target.offset();
      var offset = measureNavOffset();
      var scrollTop = targetPosition.top - offset;
      $(window).scrollTo(scrollTop);
    }, 10);

  }

  function measureNavOffset() {

    var $nav = $('#mainnav');
    var navPosition = $nav.position();
    var navHeight = $nav.height();
    var offset = navPosition.top + navHeight;

    return offset;

  }

  $(document).ready(init);

}(window, jQuery);

